import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { TranslateService } from '@interticket/core';

export function appInitializerFactory(appInitializer: AppInitializerService): () => Promise<any> {
  return (): Promise<any> => appInitializer.load();
}

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {

  constructor(
    private injector: Injector,
    private router: Router
  ) { }

  async load(): Promise<any> {
    const translate = this.injector.get(TranslateService);
    return translate.init({
      errorRedirectRoute: ['error', 'server-error'],
      translationTags: environment.translationTags,
    })
      .catch((error) => {
        console.error(error);
        return this.router.navigate(['error', 'server-error']);
      });
  }

}
